<template>
  <b-modal title="Selecione o Cliente" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE CLIENTES :::::::::::::::::::::::::::: -->
      <b-table
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterClientes(filtro)"
        :fields="fields.cliente"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="addCliente(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <template #modal-footer>
      <b-form inline>
        <b-form-input
          id="cliente-filter"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Filtre pelo nome do cliente."
          v-model="filtro"
        />
        <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
      </b-form>
      <b-button variant="info" @click="limpar()">Limpar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useClienteStore } from "@/stores/ClienteStore";
import TableFields from "@/tools/TableFields";
import Cliente from "@/models/Cliente";

export default {
  name: "ClienteListModal",

  data() {
    return {
      show: false,
      filtro: "",
      fields: new TableFields(),
    };
  },

  methods: {
    addCliente(cliente) {
      this.$emit("addCliente", cliente);
      this.show = !this.show;
    },

    limpar() {
        this.addCliente(new Cliente(0, "Todos os Clientes", "", "", "", "", "", "", ""));
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const { getFilterClientes } = storeToRefs(clienteStore);

    return {
      store,
      clienteStore,
      getFilterClientes,
    };
  },
};
</script>

<style lang="scss" scoped>
#cliente-filter {
  width: 30rem;
}
</style>
